import React, { useEffect, useState } from "react";
import { Configurations } from "../../../Utils/Configurations";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import axios from "axios";
import ImagemFukyo from "../../../Components/Imagem-Fukyo/Imagem-Fukyo";
import InsertVideo from "../../../Components/Insert-Video/Insert-Video";
import { withRouter } from "react-router-dom";

const VideosHighlightsDetails = (props) => {

    const [loading, setLoading] = useState(false)
    const [formState, setFormState] = useState(
        {
            image: '',
            idVideoEpisodio: '',
            idVideoPrograma: '',
            nome: '',
            _id: ''
        })

    const [image, setImage] = useState()
    const [imageName, setImageName] = useState()
    const [temArquivo, setTemArquivo] = useState(false)
    const [loadingSalvar, setLoadingSalvar] = useState(false)
    const [arquivoSalvo, setArquivoSalvo] = useState(false)
    const [mensagemSalvar, setMensagemSalvar] = useState(false)

    const [modalSuccessYoutube, setModalSuccessYoutube] = useState(false)
    const [msgModal, setMsgModal] = useState('')
    const [modalVideo, setModalVideo] = useState(false)
    const [loadingInfo, setLoadingInfo] = useState(true)
    const id = props.match && props.match.params && props.match.params.idVideoEpisodio;

    const handleImageChange = (e) => {
        const { value } = e.target;
        setImageName(value)
    };

    const AdicionarDestaque = () => {
        setLoading(true)

        if (temArquivo && !arquivoSalvo) {
            return setMensagemSalvar(true)
        }
        const config = new Configurations();
        const _body = {
            "plataforma": "Hub",
            "tipo": "video",
            "idVideoEpisodio": formState.idVideoEpisodio,
            "idVideoPrograma": formState.idVideoPrograma,
            "image": formState.image,
        }

        axios.post(config.apiBasePath + `/destaques-videos-podcasts/novo`, _body)
            .then((response) => {
                setLoading(false)
                setMsgModal(response.data.message)

            }).catch(error => {
                console.log("ERROR: ", error)
                setMsgModal(error.response.data.message)
            })
            .finally(() =>
                setModalSuccessYoutube(true)
            )
    }

    const editarDestaque = () => {
        setLoading(true)
        const _body = {
            plataforma: "Hub",
            tipo: "video",
            idVideoPrograma: formState.idVideoPrograma,
            idVideoEpisodio: formState.idVideoEpisodio,
            ativo: true,
            image: formState.image,
        };

        const config = new Configurations();
        axios.put(config.apiBasePath + `/destaques-videos-podcasts/${formState._id}`, _body)
            .then((response) => {
                setMsgModal(response.data.message)
                toggleModal()
            })
            .catch(error => {
                console.log("ERROR: ", error)
                setMsgModal(error.response.data.message)
                toggleModal()
            })
            .finally(() => {
            });
    }


    const onSelectFileImage = (e) => {
        setImage(e.target.files[0])
        setTemArquivo(true)
    }

    const salvarImg = async () => {
        const config = new Configurations();
        var bodyFormData = new FormData();
        bodyFormData.append('imagem', image);
        bodyFormData.append('tipo', 'banners');
        bodyFormData.append('nomeImagem', imageName);

        setLoadingSalvar(true)

        await axios.post(config.apiBasePath + `/hub/imagem/upload`, bodyFormData).then(response => {

            setFormState((prevState) => ({
                ...prevState,
                image: response.data.image,
            }));

            setLoadingSalvar(false)

            setArquivoSalvo(true)
        }).catch(err => {
            console.log("ERROR:", err)
            setLoadingSalvar(false)
        });
    }

    const toggleModalVideo = () => {
        setModalVideo(!modalVideo)
    }

    const handleModalVideo = ({ idProg, idEp, nomeEp }) => {
        toggleModalVideo();
        setFormState((prevState) => ({
            ...prevState,
            idVideoPrograma: idProg,
            idVideoEpisodio: idEp,
            nome: nomeEp,
        }));
    };

    const toggleModal = () => {
        setModalSuccessYoutube(!modalSuccessYoutube)
    }

    const getVideo = () => {
        const config = new Configurations();
        axios.get(config.apiBasePath + `/destaques-videos-podcasts/${id}`)
            .then(response => {
                setFormState((prevState) => {
                    return {
                    ...prevState,
                    image: response.data.data[0].image,
                    idVideoEpisodio: response.data.data[0].idEpisodio,
                    idVideoPrograma: response.data.data[0].idVideoPrograma,
                    nome: response.data.data[0].dadosConteudo.nome,
                };
                });
            })
            .catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() => {
                setLoadingInfo(false)
            });
    }

    useEffect(() => {
        if (props.match && props.match.params && props.match.params.idVideoEpisodio) {
            getVideo();
            setFormState((prevState) => ({
                ...prevState,
                _id: id,
            }));
        } else {
            setLoadingInfo(false);
        }
    }, [])

    const podeSalvar = () => {
        const programaValido = !!formState.idVideoPrograma && formState.idVideoPrograma !== "";
        const episodioValido = !!formState.idVideoEpisodio && formState.idVideoEpisodio !== "";
        const imagemValida = !!formState.image && formState.image.trim() !== "";
        const fluxoEdicao = !!props.location.state;

        if (fluxoEdicao) {            
            return true;
        } else {
            return (programaValido && episodioValido) && imagemValida && (temArquivo || arquivoSalvo);
        }
    };


    return (
        loadingInfo ? <div className="spinner-border text-success" role="status" />
            :
            <>
                <div className="row">
                    <div className="col-12 py-2">
                        <div className="row no-gutters align-items-center">
                            <div className="col-12 col-lg-8 text-center text-lg-left">
                                <h2 className="title-1 d-none d-lg-block">{props.location.state ? 'Vídeos - Editar Destaque' : 'Vídeos - Novo Destaque'}</h2>
                            </div>
                            <div className="col-12 col-lg-4 text-center text-lg-right">
                                <div className="row no-gutters">
                                    <div className="col py-2 py-lg-0">
                                        <button onClick={() => window.history.go(-1)} className="btn btn-outline-secondary">voltar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="row no-gutters px-3">

                        <div className="col-4 d-lg-block d-none pr-3 ">
                            <p className="pt-3"><strong>Imagem atual</strong></p>
                            <ImagemFukyo
                                className={`img img-fluid`}
                                src={formState.image}
                                alt={`imagem-destaque`}
                            />
                        </div>

                        <div className={'py-3 col-8'}>
                            <p className="pl-2"> <strong>Titulo: </strong> {formState.nome}</p>

                            <button className="btn btn-outline-info my-3" onClick={() => toggleModalVideo()}>
                                Escolher Vídeo
                            </button>

                            <ul>
                                <li className="pl-2 m-0" style={{ fontSize: '14px' }}>Usar traço (-) para fazer a separação das palavras</li>
                                <li className="pl-2 m-0" style={{ fontSize: '14px' }}>Proporção adequada de imagem: 2x1</li>
                            </ul>

                            <p className="pl-2" style={{ fontSize: '14px' }}>Exemplo: destaque-nrh-v5-ep12</p>
                            {temArquivo && <input name="image" type="text" className="form-control" autoComplete="off" value={imageName} onChange={handleImageChange} required={true} />}

                            <label className="pl-2 pt-3"><strong>Imagem:</strong></label>
                            <br />
                            <input type="file" accept={".jpg,.jpeg,.png"} className="pb-3" onChange={onSelectFileImage} />
                            <br />
                            {temArquivo ?
                                loadingSalvar ?
                                    <div className="spinner-border text-success" role="status" />
                                    :
                                    <div>
                                        <button onClick={() => salvarImg()} disabled={props.location.state ? null : !imageName} className="btn btn-outline-success pl-3">salvar imagem</button>
                                        {mensagemSalvar && <small className="text-danger ml-3">Necessário salvar imagem</small>}
                                    </div>
                                : null}
                        </div>
                        <div className='col-12 text-right py-2'>
                            {loading ? <div className="spinner-border text-success" role="status" />
                                :
                                <button className='btn btn-outline-success'
                                    disabled={!podeSalvar()}
                                    onClick={() => props.location.state ? editarDestaque() : AdicionarDestaque()}>
                                    {props.location.state ? 'Salvar banner' : 'Incluir banner'}
                                </button>}

                        </div>

                    </div>



                </div>
                <Modal isOpen={modalSuccessYoutube} toggle={toggleModal}>
                    <ModalHeader toggle={toggleModal}>
                        Vídeos - Destaques
                    </ModalHeader>
                    <ModalBody>
                        {msgModal}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="success" onClick={() => window.history.go(-1)}>ok</Button>
                    </ModalFooter>
                </Modal>

                <InsertVideo
                    isOpen={modalVideo}
                    toggle={toggleModalVideo}
                    handleModalVideo={handleModalVideo}
                />
            </>
    )
}


export default withRouter(VideosHighlightsDetails);